import React from 'react';
import { DescriptionBlock } from 'components/shared/infoBlocks/description';
import styles from './styles.module.scss';

export const SelectedOptionDescription = ({ description }: { description: string }): JSX.Element => {
  return <DescriptionBlock description={description} classname={styles.description} />;
};
